import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { api } from '../api/client';
import { useAuth } from '../auth/AuthContext';
import DashboardLayout from '../components/DashboardLayout';
import { Skeleton } from '../components/Skeleton';
import SeverityBadge from '../components/SeverityBadge';
import { EmptySignal } from '../components/illustrations';
import { formatDateTime } from '../lib/time';

const FILTERS = ['all', 'critical', 'warning'];

export default function AlertsPage() {
  const { t, i18n } = useTranslation();
  const { activeServerKey } = useAuth();
  const lang = i18n.resolvedLanguage;
  const [loading, setLoading] = useState(true);
  const [alerts, setAlerts] = useState([]);
  const [filter, setFilter] = useState('all');

  useEffect(() => {
    setLoading(true);
    api.alerts(200, activeServerKey || undefined).then((r) => setAlerts(r.alerts || [])).finally(() => setLoading(false));
  }, [activeServerKey]);

  const shown = filter === 'all' ? alerts : alerts.filter((a) => a.severity === filter);

  return (
    <DashboardLayout title={t('dashboard.recent_alerts')} crumb={t('dashboard.title')} heading={false}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 'var(--sp-5)', flexWrap: 'wrap', gap: 12 }}>
        <h1 className="page-title" style={{ margin: 0 }}>{t('dashboard.recent_alerts')}</h1>
        <div className="lang-toggle">
          {FILTERS.map((f) => (
            <button key={f} className={filter === f ? 'active' : ''} onClick={() => setFilter(f)}>
              {f === 'all' ? (lang === 'tr' ? 'Tümü' : 'All') : t(`severity.${f}`)}
            </button>
          ))}
        </div>
      </div>

      {loading ? (
        <div className="card">
          {[0, 1, 2, 3].map((i) => (
            <Skeleton key={i} className="sk-text" style={{ margin: '14px 0' }} />
          ))}
        </div>
      ) : shown.length === 0 ? (
        <div className="empty-state">
          <EmptySignal />
          <h3>{t('dashboard.no_alerts')}</h3>
        </div>
      ) : (
        <div className="card" style={{ padding: 0 }}>
          <div className="list">
            {shown.map((a) => (
              <div className="list-row" key={a.id} style={{ padding: 'var(--sp-4)' }}>
                <SeverityBadge severity={a.severity} />
                <div className="row-main">
                  <div style={{ fontWeight: 500 }}>{t(`metric.${a.type}`, a.type)}</div>
                  <div style={{ color: 'var(--text-3)', fontSize: 12.5 }}>{a.message}</div>
                </div>
                <div className="row-time">{formatDateTime(a.triggeredAt, lang)}</div>
              </div>
            ))}
          </div>
        </div>
      )}
    </DashboardLayout>
  );
}
